import {
  Expose, Exclude,
} from 'class-transformer';
import { Sex } from 'shared/sex.enum';

@Exclude()
export class AnimalParents {
  @Expose()
  animalId: string;

  @Expose()
  studId: string;

  @Expose()
  sireId: string;

  @Expose()
  sireStudId: string;

  @Expose()
  damId: string;

  @Expose()
  damStudId: string;

  @Expose()
  sex: Sex;
}
